import useUserStoreV2 from "store/user-store-v2/useUserStoreV2";

const withAppSideBarProfileName = (Component: React.ComponentType<any>) => {
  return (props: any) => {
    const { tgUserName } = useUserStoreV2();
    return <Component {...props} tgUserName={tgUserName} />;
  };
};

export default withAppSideBarProfileName;
